import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { Form } from 'antd';
import { emptyFun } from '@untils/common';
import { uiType } from './merge';
import moment from 'moment';
import './index.less';

const GeneralForm = (props, ref) => {
  const {
    schema = [],
    mapName = [],
    functionMap = {},
    initialValues,
    controler = [],
    width = '100%',
    className = '',
    getFields = emptyFun,
    getSpecificField = emptyFun,
    layout = 'horizontal',
    labelCol,
    wrapperCol,
  } = props;
  const [formDom, setFormDom] = useState();
  const [controlObj, setControlObj] = useState({});
  const formRef = useRef();
  const [form] = Form.useForm();

  // 特殊处理上传组件
  functionMap.fillUpload = (name, fileList) => {
    const files = fileList.map(item => {
      const { response = {} } = item;

      return response.key;
    });

    form.setFieldsValue({
      [name]: files,
    });
  };

  // 特殊处理app上传组件
  functionMap.setOtherValue = (name, value) => {
    form.setFieldsValue({
      [name]: value,
    });
  };
  // 需要根据数据展示隐藏的dom
  functionMap.controlChange = (name, target = {}) => {
    const value = (target.target && target.target.value) || target;

    setControlObj({
      ...controlObj,
      [name]: value,
    });
    getSpecificField({
      [name]: value,
    });
  };

  useEffect(() => {
    setControlObj(initialValues);
    // formRef.current.setFieldsValue(initialValues);
    formRef.current.resetFields();
  }, [initialValues]);

  useEffect(() => {
    const formChilren = schema.filter(Boolean).map((item, idx) => {
      return uiType(item, functionMap, controlObj, controler, width, idx);
    });

    setFormDom(formChilren);
  }, [schema, controlObj]);

  const onConfirm = () => {
    return formRef.current
      .validateFields()
      .then(values => {
        const result = { ...values };

        mapName.forEach(item => {
          const { name, keys = [], isTimePicker = false } = item;

          // 单独解出来时间类型
          if (result[name] instanceof Array) {
            if (result[name]) {
              result[name].forEach((time, index) => {
                result[keys[index]] = isTimePicker
                  ? time.format('HH:mm:ss')
                  : (moment(time).valueOf() / 1000).toFixed(0);
              });
            } else {
              result[keys[0]] = '';
              result[keys[1]] = '';
            }
            delete result[name];
          } else {
            result[name] = isTimePicker
              ? result[name].format('HH:mm:ss')
              : result[name] && (moment(result[name]).valueOf() / 1000).toFixed(0);
          }
        });
        return result;
      })
      .catch(errorInfo => {
        return errorInfo;
      });
  };

  useImperativeHandle(ref, () => ({
    onConfirm,
    resetFields: form.resetFields,
  }));

  return (
    <Form
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      layout={layout}
      initialValues={initialValues}
      form={form}
      className={`general-form ${className}`}
      onFinish={onConfirm}
      ref={formRef}
      onChange={() => getFields(form.getFieldValue())}
    >
      {formDom}
    </Form>
  );
};

export default forwardRef(GeneralForm);
